import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableFooter from '@mui/material/TableFooter';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';

import axios from 'axios';
import Card from '@/components/Card/Card';
import CardBody from '@/components/Card/CardBody';
import CardHeader from '@/components/Card/CardHeader';
import GridContainer from '@/components/Grid/GridContainer';
import GridItem from '@/components/Grid/GridItem';
import { API_BASE_URL } from '@/config';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';

import moment from 'moment';
import { DeleteRounded } from '@mui/icons-material';

const ACHFiles = () => {
  const { t } = useTranslation();
  const [files, setFiles] = useState([]);
  const [facilities, setFacilities] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [facility, setFacility] = useState('');
  const [paymentType, setPaymentType] = useState('ACH');

  const handlePaymentChange = (e) => {
    setPaymentType(e.target.value);
  };
  const selectFacility = (event) => {
    setFacility(event.target.value);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const deleteFile = async (id) => {
    if (confirm(t('achFiles.actions.deleteConfirmation')) == true) {
      await axios.delete(API_BASE_URL + '/nachfile/' + id);
      getFiles();
    }
  };
  const getFiles = async () => {
    const filesList = await axios.post(API_BASE_URL + '/adminACHFilesList', {
      facilityId: facility,
      paymentType: paymentType,
    });
    setFiles(filesList.data);
  };
  useEffect(() => {
    const fetchFiles = async () => {
      getFiles();
    };
    fetchFiles();
  }, [facility, paymentType]);

  useEffect(() => {
    const fetchFacilities = async () => {
      const response = await axios.get(API_BASE_URL + '/facilitiesPro');
      setFacilities(response.data);
    };
    fetchFacilities();
  }, []);

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color='primary'>
            <h4>{t('achFiles.title')}</h4>
          </CardHeader>

          <CardBody>
            <div>
              <div className='t-header'>
                <div className='t-header-right'>
                  <div className='custom-search-box'>
                    <div className='custom-select'>
                      <select
                        className='full-width-elem'
                        id='Facility'
                        onChange={selectFacility}>
                        <option value='' style={{ fontWeight: 'bold' }}>
                          {t('achFiles.filters.facilitiesPlaceholder')}
                        </option>
                        {facilities.map((item) => {
                          return (
                            <>
                              <option
                                value={item.id}
                                className='parent'
                                style={{ fontWeight: 'bold' }}
                                key={item.id}>
                                {item.name}
                              </option>
                            </>
                          );
                        })}
                      </select>
                    </div>
                    <span className='search-icon'></span>
                  </div>
                  <div
                    style={{ margin: '0 10px', width: '200px' }}
                    className='custom-search-box'>
                    <div className='custom-select'>
                      <select
                        className='full-width-elem'
                        id='Facility'
                        onChange={handlePaymentChange}>
                        <option value='ACH' style={{ fontWeight: 'bold' }}>
                          {t('achFiles.filters.achPayments')}
                        </option>
                        <option
                          value='POSITIVE_PAY'
                          style={{ fontWeight: 'bold' }}>
                          {t('achFiles.filters.positivePay')}
                        </option>
                      </select>
                    </div>
                    <span className='search-icon'></span>
                  </div>
                </div>
              </div>
              <Table width='100%' id='template'>
                <TableHead>
                  <TableRow>
                    <TableCell width='15%'>
                      {t('achFiles.table.createdAt')}
                    </TableCell>
                    <TableCell width='10%'>
                      {t('achFiles.table.facilityName')}
                    </TableCell>
                    <TableCell width='10%'>
                      {t('achFiles.table.generatedBy')}
                    </TableCell>
                    <TableCell width='5%'>
                      {t('achFiles.table.numberOfRefunds')}
                    </TableCell>
                    <TableCell width='10%'>
                      {t('achFiles.table.reference')}
                    </TableCell>
                    <TableCell width='5%'>
                      {t('achFiles.table.totalAmount')}
                    </TableCell>
                    <TableCell width='15%'>
                      {t('achFiles.table.fileName')}
                    </TableCell>
                    <TableCell width='5%'></TableCell>
                  </TableRow>
                </TableHead>
                {files && files.length > 0 ? (
                  <TableBody>
                    {(rowsPerPage > 0
                      ? files.slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage,
                        )
                      : files
                    ).map((obj, index) => (
                      <TableRow className='txtalign' key={index}>
                        <TableCell>
                          {obj.created_at
                            ? moment(obj.created_at).format(
                                'MM-DD-YYYY:hh:mm A',
                              )
                            : '-'}
                        </TableCell>
                        <TableCell>{obj && obj.name}</TableCell>
                        <TableCell>{obj && obj.created_by}</TableCell>
                        <TableCell>{obj.no_of_refunds}</TableCell>
                        <TableCell>{obj.reference_code ?? ''}</TableCell>
                        <TableCell>
                          $ {parseFloat(obj.total_amount ?? 0).toFixed(2)}
                        </TableCell>
                        <TableCell>{obj.file_name}</TableCell>
                        <TableCell>
                          <a
                            href={
                              API_BASE_URL + '/getFile?filePath=' + obj.file_url
                            }>
                            <div>
                              <CloudDownloadIcon />
                            </div>
                          </a>
                          <a onClick={() => deleteFile(obj.id)}>
                            <div>
                              <DeleteRounded />
                            </div>
                          </a>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                ) : (
                  <TableBody>
                    <TableRow>
                      <TableCell>
                        {t('achFiles.table.noTransactionData')}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
                <TableFooter>
                  <TableRow>
                    <TablePagination
                      rowsPerPageOptions={[
                        5,
                        10,
                        25,
                        { label: t('achFiles.pagination.all'), value: -1 },
                      ]}
                      colSpan={3}
                      count={files.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      SelectProps={{
                        inputProps: {
                          'aria-label': t('achFiles.pagination.rowsPerPage'),
                        },
                        native: true,
                      }}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </div>
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
};

export default ACHFiles;
